import { useEffect, useState } from 'react';

// @see https://usehooks.com/useWindowSize/
export const useWindowSize = (viewport: number): boolean => {
  const [windowSize, setWindowSize] = useState<boolean>(globalThis.innerWidth < viewport);
  useEffect(() => {
    function handleResize() {
      setWindowSize(globalThis.innerWidth < viewport);
    }
    globalThis.addEventListener('resize', handleResize);
    handleResize();
    return () => globalThis.removeEventListener('resize', handleResize);
  }, [viewport]);
  return windowSize;
};
